import { useCallback, useState } from "react";

import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { Container, LayoutStandard } from "components";
import { AuthorityConstants } from "constant";
import { UserService } from "services";
import { CreditStatus } from "types";
import { AppUtils } from "utils";

import ClientCreditStatusFilterBar from "../clients/list/ClientCreditStatusFilterBar";
import ClientStatusFilterBar from "../clients/list/ClientStatusFilterBar";
import { ClientStatusFilter } from "../clients/list/ClientStatusFilterBar";
import ClientsList from "../clients/list/list";

const ReplacementClientsPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [clientStatus, setClientStatus] = useState<ClientStatusFilter>("ALL");
  const [creditRequestStatus, setCreditRequestStatus] = useState<CreditStatus | undefined>();

  const handleClientStatusChange = useCallback((status: ClientStatusFilter) => {
    setClientStatus(status);
    setCreditRequestStatus(undefined);
  }, []);

  const fetch = useCallback((page: number, search: string | undefined, source?: string) => {
    UserService.userClients({
      page,
      search,
      phase: "ALL",
      source,
      clientStatus: clientStatus === "ALL" ? undefined : clientStatus,
      creditRequestStatus,
      agent: true,
      absence: true,
    });
  }, [clientStatus, creditRequestStatus]);

  return (
    <LayoutStandard
      authority={AuthorityConstants.ROLE_CR}
      title={AppUtils.composeTabTitle(t("header.replacement_clients"))}
    >
      <Container>
        <ClientStatusFilterBar value={clientStatus} onChange={handleClientStatusChange} allowAll />
        <ClientCreditStatusFilterBar
          clientStatus={clientStatus}
          value={creditRequestStatus}
          onChange={setCreditRequestStatus}
        />
        <ClientsList
          key={searchParams.get("source") ?? "all"}
          fetch={fetch}
          clientStatus={clientStatus}
          creditRequestStatus={creditRequestStatus}
        />
      </Container>
    </LayoutStandard>
  );
};

export default ReplacementClientsPage;
